import BaseAtlaskitIcon, { IconProps as AtlasKitIconProps } from '@atlaskit/icon';
import React from 'react';

import { IconType } from '../../../clients/sites/model';
import { IconPropsWithOptionalLabel } from '../ProductCard/ProductIcon';
/**
 * Due to remote SVG's downloading through fetch, there is a delay between when the network request starts and when they are rendered.
 * This causes them to disappear each time Switcher is mounted.
 * Adding this cache means that we can store the SVG content between mounts and not need to worry about re-fetching the content.
 */
const svgCache: Record<string, string> = {};

type RemoteIconProps = Partial<AtlasKitIconProps> & {
  url: string;
};

const RemoteIcon = (props: RemoteIconProps) => {
  const { url, ...svgProps } = props;
  const [svg, setSvg] = React.useState<string>(svgCache[url]);

  React.useEffect(() => {
    if (!svgCache[url]) {
      fetch(url)
        .then(res => res.text())
        .then(content => {
          setSvg(content);
          svgCache[url] = content;
        });
    }
  }, [url]);
  return <BaseAtlaskitIcon label={svgProps.label || ''} dangerouslySetGlyph={svg} {...svgProps} />;
};

export const createRemoteIcon = (url: string, svgProps?: Partial<AtlasKitIconProps>): IconType => (
  props: IconPropsWithOptionalLabel,
) => <RemoteIcon url={url} {...svgProps} {...props} />;
